import React, { Component } from 'react';
import Pdf from '../assets/FariaHabibCV_Updated (1).pdf';
import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/images/IMG_8519.jpg";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';


export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
 
  const [activeLink, setActiveLink] = useState('home');
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);
  const toRotate = [ "CS PhD Student", "Automation Engineer", "Tech Blogger" ];
  const period = 2000;
  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  }
  const handleViewPDF = () => {
    window.open(Pdf);
  };
  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => { clearInterval(ticker) };
  }, [text])

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex(prevIndex => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex(prevIndex => prevIndex + 1);
    }
  }

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn banner-content" : "banner-content"}>
                <span className="tagline">Welcome to my Portfolio</span>
                <h1>
                  Hi! I'm Faria
                  <br />
                  <span className="txt-rotate">
                    <span className="wrap">{text}</span>
                  </span>
                </h1>
                <div className="banner-bio">
                  <p>👋 Hi, I'm Faria Habib — a Bangladeshi CS PhD student at UIC, figuring out how to make technology less frustrating and more inclusive for everyone. My research is all about HCI, and I genuinely care about understanding how different people interact with tech and making sure nobody gets left behind.</p>
                  <p>I also have 4 years of experience as a software automation engineer — so I'm equally comfortable talking research and rolling up my sleeves to write real, working code.</p>
                  <p>Outside of work and academia? I run on coffee ☕, live for good music 🎵, and feel most like myself when I'm exploring somewhere new ✈️. Basically, if there's a good playlist and a window seat on a flight — I'm thriving.</p>
                </div>
                <button className="resume-btn" onClick={handleViewPDF}>
                  View Resume <ArrowRightCircle size={20} />
                </button>
              </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn banner-img-wrap" : "banner-img-wrap"}>
                  <div className="banner-img-glow" />
                  <img src={headerImg} alt="Faria Habib" className="banner-photo" />
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}